import {
    EditListPopup,
    PopupComponent,
    PopupElements
} from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { initCompanyContact } from './main';
import { SortingList } from './sorting-list';
import SearchFilter from './search-filter';

export default class CompanyContact {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: document.querySelector('[data-action="AddContact"]'),
            editButtons: Array.from(
                document.querySelectorAll('[data-action="EditContact"]')
            ),
            deleteButtons: Array.from(
                document.querySelectorAll('[data-action="DeleteContact"]')
            )
        };

        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerContactForm',
            removeItemUrl: 'CustomerCenter/DeleteCompanyContact',
            addItemUrlParameters: [
                {
                    fieldName: 'type',
                    dataAttributeTargetValue: 'data-contact-type'
                }
            ],
            editItemUrlParameters: [
                {
                    fieldName: 'contactId',
                    dataAttributeTargetValue: 'data-contact-id'
                },
                {
                    fieldName: 'type',
                    dataAttributeTargetValue: 'data-contact-type'
                }
            ],
            removeItemUrlParameters: [
                {
                    fieldName: 'contactId',
                    dataAttributeTargetValue: 'data-contact-id'
                }
            ]
        };

        new EditListPopup().init(
            'ContactForm',
            'contact-form-popup',
            popupElements,
            popupComponent,
            () => this.reloadComponent(),
            () => this.reloadComponent()
        );

        const component = document.querySelector(
            '[data-component=CustomerCompanyContacts]'
        );
        const filter = new SearchFilter(component, initCompanyContact);
        new SortingList(component, initCompanyContact, [], filter);
    }

    private reloadComponent(): void {
        const action = new ActionCreator().reloadComponent(
            'CustomerCompanyContacts'
        );

        action.successAction = () => initCompanyContact();
        new AjaxDispatcher().dispatchGetAction(action);
    }
}
